<a class="{{ appearance }}" *ngIf="!(isLogged$ | async)" [routerLink]="[routerLinkNotLogged]">
  {{ textNotLogged }}
  <ng-content></ng-content>
</a>

<a class="{{ appearance }}" *ngIf="isLogged$ | async" [routerLink]="[routerLinkLogged]">
  {{ textLogged }}
  <ng-content></ng-content>
</a>
